// @ts-nocheck
import { logoLinksSearchStyles, LogoLinksSearchStyles } from "@store/Overrides/Widgets/Header/LogoLinksSearch";
import mergeProps from "@toolkit/Framework/Common/Utilities/mergeProps";
import { css } from "styled-components";

Object.assign(logoLinksSearchStyles, {
    searchWrapper: mergeProps(logoLinksSearchStyles.searchWrapper, {
        css: css`
            text-align: center;
            > div /* Zone */ {
                margin: auto;
            }
        `,
    }),
} as LogoLinksSearchStyles);
